/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthLoginResponse } from './AuthLoginResponse';

export type AuthLoginResponseApiRespoonse = {
    data?: AuthLoginResponse;
    status?: AuthLoginResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuthLoginResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

